<template lang="pug">
  .ds-list
    v-data-table(v-show="false" :headers="headers")
    app-table(
      v-model="activeItems"
      :headers="headers"
      :list="list"
      item-key="id"
      hide-default-footer
      multi-sort=false
      :server-items-length="list.length"
      :single-select="false"
      :loading="loading"
      :show-select="false"
      :mobile-breakpoint='NaN'
      :sort-by.sync="sortModel.by"
      :sort-desc.sync="sortModel.desc"
      @update:sort-desc="updateSorting"
      hide-default-header
      class="app-table-new v-data-table theme--light"
    )
      template(v-slot:item="{item, select, isSelected, index}")
        item(
          :item="item"
          :isSelected="isSelected"
          :select="select"
          :index="index"
          :key="item.id"
          :activeItems="activeItems"
          :primaryPagination="primaryPagination"
          @needToUpdate="$emit('needToUpdate')"
        )
        total-item(v-if="index === list.length - 1" :totals="totals")
      template(#footer)
        .pagination(v-if="pagination")
          .pagination__more
            load-more-button(:loading="loading" :pagination="pagination" @loadMore="loadMore")
</template>

<script>
import SortModel from '../../core/drivingSchool-sortModel'

export default {
  name: 'DrivingSchoolPageList',

  props: {
    list: Array,
    totals: Object,
    headers: Array,
    loading: Boolean,
    pagination: Object,
    primaryPagination: Object
  },

  data: () => ({
    activeItems: [],
    sortModel: null
  }),

  computed: {
    disabledLoadingMore() {
      if (!this.pagination) return true
      if (this.loading) return true
      if (!this.pagination.next) return true
      return false
    },
  },

  created() {
    this.initSortModel()
  },

  methods: {
    initSortModel() {
      this.sortModel = new SortModel(this.$route.query)
    },

    loadMore() {
      if (!this.pagination) return
      this.$emit('loadMore')
    },

    async updateSorting() {
      let data = this.sortModel.getApiData(this.$route.query)
      let ordering
      if (data.ordering.length) ordering = data.ordering
      this.$emit('change:sorting', ordering)
    }
  },

  components: {
    appTable: () => import('@/components/global/GroupedTable.vue'),
    item: () => import('./SchoolListItem.vue'),
    totalItem: () => import('./SchoolListTotalItem.vue'),
    loadMoreButton: () => import('@/components/widget/LoadMoreButton.vue')
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/tableNew';

.app-table-new .v-data-table tbody tr td:first-child {
  width: 32px;
  height: 32px;
}

.ds-list {
  min-height: 100vh;
}

.task-app-table {
  display: table;
  width: 100%;
}
</style>
